import { useSyncExternalStore } from 'react';

type Listener = () => void;

export const IAP_XHR_HEADERS = Object.freeze({
  'X-Requested-With': 'XMLHttpRequest',
});

let isExpired = false;
const listeners = new Set<Listener>();

export const isIapSessionExpiredResponse = (response?: Response): boolean =>
  response?.status === 401 &&
  response.headers.get('x-goog-iap-generated-response') === 'true';

/** Marks the session as expired on an IAP 401 and returns whether the response was one. */
export function markIapSessionExpired(response?: Response): boolean {
  if (!isIapSessionExpiredResponse(response)) {
    return false;
  }
  if (!isExpired) {
    isExpired = true;
    listeners.forEach((listener) => listener());
  }
  return true;
}

function subscribeToIapSessionExpiry(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const isIapSessionExpired = (): boolean => isExpired;

export const useIapSessionExpired = (): boolean =>
  useSyncExternalStore(
    subscribeToIapSessionExpiry,
    isIapSessionExpired,
    () => false,
  );
